export default "__VITE_ASSET__abb0b77c__"